module.exports = __webpack_public_path__ + "static/media/Customized-illustration-Copy.60ae381d.svg";